import { createSvgIcon } from '@mui/material/utils';
import React from 'react';

export const MoveRight3 = createSvgIcon(
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.3333 8H5.33333"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinejoin="round"
    />
    <path
      d="M12 4.66667L15.3333 8L12 11.3333"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinejoin="round"
    />
    <path
      d="M3.33333 2H0.666667V14H3.33333V2Z"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinejoin="round"
    />
  </svg>,
  'MoveRight3'
);
